import BaseForm from "@common-components/form/components/BaseForm";
import RootStore from "@stores/RootStore";

export default class RegistrationForm extends BaseForm {
    constructor(hooks: any, fields: any, rootStore: RootStore) {
        super(hooks, fields, rootStore)
    }

    setup() {
        return {
            fields: [
                {
                    name: 'firstName',
                    label: 'Ime',
                    placeholder: 'Unesi ime',
                    rules: 'required|string'
                },
                {
                    name: 'lastName',
                    label: 'Prezime',
                    placeholder: 'Unesi prezime',
                    rules: 'required|string'
                },
                {
                    name: 'emailAddress',
                    label: 'Email adresa',
                    placeholder: 'Unesi e-mail adresu',
                    rules: 'required|email|checkUser',
                },
                {
                    name: 'password',
                    label: 'Lozinka',
                    placeholder: 'Unesi lozinku',
                    rules: 'required|string|min:6',
                    type: "password"
                },
                {
                    name: 'phoneNumber',
                    label: 'Kontakt broj',
                    placeholder: 'Unesi kontakt broj',
                    rules: 'required|numeric',
                    output: (value: string) => value === '' ? null : value
                }
            ],
        };
    }
}